import CheckIcon from './CheckIcon';
import DeleteIcon from './DeleteIcon';
import SquareCheckBox from './SquareCheckBox';
import CrossIcon from './CrossIcon.svg';
import GreenCheck from './GreenCheck.svg';
import SolidGreenCheck from './SolidGreenCheck.svg';
import SolidCross from './SolidCross.svg';
import CongratulationsIcon from './CongratulationsIcon.svg';
import SearchIcon from './SearchIcon.svg';
import BlackCross from './BlackCross.svg';
import EditIcon from './EditIcon.svg';
import EyeOpen from './EyeOpen.svg';
import EyeClosed from './EyeClosed.svg';

export default {
  CheckIcon,
  DeleteIcon,
  SquareCheckBox,
  CrossIcon,
  SolidCross,
  GreenCheck,
  SolidGreenCheck,
  CongratulationsIcon,
  SearchIcon,
  BlackCross,
  EditIcon,
  EyeOpen,
  EyeClosed,
};
